import { LocalStorageEnums } from 'src/shared/enums';

export const getLocalStorageValue = <T>(key: string): T | null => {
  const storedValue = localStorage.getItem(key);

  if (!storedValue) {
    return null;
  }

  try {
    return JSON.parse(storedValue);
  } catch {
    return null;
  }
};

export const clearLocalStorageValues = (exceptions: LocalStorageEnums[] = []): void => {
  const DEFAULT_EXCEPTIONS: LocalStorageEnums[] = [
    LocalStorageEnums.APP_REGION,
    LocalStorageEnums.LOGGED_IN_WITH_SSO,
    ...exceptions,
  ];

  const storedValues = Object.values(LocalStorageEnums).filter((value) => !DEFAULT_EXCEPTIONS.includes(value));
  for (const value of storedValues) {
    localStorage.removeItem(value);
  }
};
